/* Dripcoffee · phone buy bar that mirrors the product form's main button */
(function () {
  if (customElements.get('dc-sticky-atc')) return;

  class DcStickyAtc extends HTMLElement {
    connectedCallback() {
      // Moving the bar to <body> reconnects it; set up only once
      if (this.ready) return;
      this.ready = true;
      const id = this.dataset.section;
      this.main = document.getElementById(`ProductSubmitButton-${id}`);
      this.priceRoot = document.getElementById(`price-${id}`);
      this.btn = this.querySelector('[data-sticky-add]');
      this.label = this.querySelector('[data-sticky-label]');
      this.price = this.querySelector('[data-sticky-price]');
      if (!this.main) return;

      // Move to <body> so the section's stacking context can't trap the fixed bar
      document.body.appendChild(this);

      this.phone = window.matchMedia('(max-width: 749px)');
      this.pastButton = false;
      this.footerVisible = false;

      // Measure on scroll: a jump past the button (anchor link, fast fling) never
      // crosses an IntersectionObserver threshold, so observers alone miss it
      this.footer = document.querySelector('.footer, footer');
      let queued = false;
      const measure = () => {
        queued = false;
        const main = document.getElementById(`ProductSubmitButton-${id}`) || this.main;
        this.pastButton = main.getBoundingClientRect().bottom < 0;
        this.footerVisible = this.footer ? this.footer.getBoundingClientRect().top < window.innerHeight : false;
        this.update();
      };
      const onScroll = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(measure);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      measure();

      this.btn.addEventListener('click', () => {
        // Re-read the button in case a variant change re-rendered it
        const main = document.getElementById(`ProductSubmitButton-${id}`) || this.main;
        if (main.disabled) return;
        main.click();
      });

      this.sync();
      new MutationObserver(() => this.sync()).observe(this.main, { attributes: true, childList: true, subtree: true, characterData: true });
      if (this.priceRoot) new MutationObserver(() => this.sync()).observe(this.priceRoot, { childList: true, subtree: true, characterData: true });
      this.phone.addEventListener('change', () => this.update());
    }

    sync() {
      this.btn.disabled = this.main.disabled;
      const text = this.main.textContent.trim();
      if (text) this.label.textContent = text;
      if (this.priceRoot) {
        const p =
          this.priceRoot.querySelector('.price--on-sale .price-item--sale') ||
          this.priceRoot.querySelector('.price__regular .price-item--regular') ||
          this.priceRoot.querySelector('.price-item--last');
        if (p && p.textContent.trim()) this.price.textContent = p.textContent.trim();
      }
    }

    update() {
      const show = this.pastButton && !this.footerVisible && this.phone.matches;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', String(!show));
      this.btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('dc-sticky-on', show);
    }
  }

  customElements.define('dc-sticky-atc', DcStickyAtc);
})();
